import axios from 'axios'
import { pathOr } from 'ramda'
import { IsDev } from '../../../helpers/build'
import { asyncTimeout } from '../../../helpers/utils'

import setValue from './setValue'
import { GET_RATES_ENDPOINT, HOTEL_ID } from './getRooms'
import openPopup from '../../PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from '../../PopupConstructor/constants'
import toggleGlobalLoader from '../../loader/actions/loaderActions'
import shoppingCartAttempt from './shoppingCartAttempt'

let data = pathOr({}, ['default'], require('./mocks/options'))

export default (roomId, id) => async (dispatch, getState) => {
  dispatch(toggleGlobalLoader(true))
  dispatch(setValue('roomOptions', []))
  const {
    form: {
      searchFilters: { isMultipleBooking },
    },
  } = getState()
  let url = 'https://5b3a1a5a356f570014d0baa0.mockapi.io/hotel/1/room/1/offer/1/options'
  if (GET_RATES_ENDPOINT) {
    url = `${GET_RATES_ENDPOINT}/${HOTEL_ID}/room/${roomId}/offer/${id}/options${window.location.search}`
  }

  try {
    if (IsDev) {
      console.info(`%c GET /hotel/${HOTEL_ID}/room/${roomId}/offer/${id}/options from mock data`, 'color: #67a9ad; font-weight: bold;')
      await asyncTimeout(1)
    } else {
      data = pathOr('', ['data'], await axios.get(url))
    }

    await dispatch(setValue('selectedRate', `${roomId}|${id}`))
    await dispatch(setValue('roomOptions', data))

    // add to basket for preselecting in case of single booking
    if (!isMultipleBooking) {
      await dispatch(shoppingCartAttempt())
    }

    dispatch(toggleGlobalLoader(false))
  } catch (e) {
    const errData = pathOr({}, ['response', 'data'], e)
    if (errData.message) {
      dispatch(openPopup(GLOBAL_ERROR_POPUP, errData))
    }

    dispatch(setValue('roomOptions', []))
    dispatch(toggleGlobalLoader(false))
  }
}
